import React, { useEffect, useMemo, useState } from "react";
import queries from "../helpers/queries";
import { withUser } from "../Contexts/user";
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useQuery } from "@apollo/react-hooks";

const Campaigns = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const { data: campaignsData } = useQuery(queries.FETCH_CAMPAIGNS_AGENT, {
        fetchPolicy: "network-only",
    });

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const campaigns = useMemo(
        () => campaignsData?.fetchCampaignsAgent || [],
        [campaignsData]
    );

    const selectedIndex = useMemo(
        () =>
            campaigns.findIndex(
                (campaign) => campaign._id === selectedCampaign?._id
            ),
        [campaigns, selectedCampaign]
    );

    const handleCampaignClick = (campaign) => {
        setSelectedCampaign(campaign);
        setShowModal(true);
    };

    const showPreviousCampaign = (e) => {
        e.stopPropagation();
        if (campaigns.length === 0 || selectedIndex < 0) {
            return;
        }

        const previousIndex =
            selectedIndex === 0 ? campaigns.length - 1 : selectedIndex - 1;
        setSelectedCampaign(campaigns[previousIndex]);
    };

    const showNextCampaign = (e) => {
        e.stopPropagation();
        if (campaigns.length === 0 || selectedIndex < 0) {
            return;
        }

        const nextIndex =
            selectedIndex === campaigns.length - 1 ? 0 : selectedIndex + 1;
        setSelectedCampaign(campaigns[nextIndex]);
    };

    return (
        <div className="campaigns-page">
            <div className="campaigns-container">
                <h1 className="campaigns-title">Campaign Highlights</h1>
                <p className="text-sm text-gray-400 mb-4">
                    Latest promotional campaigns, incentives, and key updates.
                </p>
                <div className="campaigns-grid">
                    {campaigns.map((campaign) => (
                        <div
                            key={campaign._id}
                            className="campaign-item"
                            onClick={() => handleCampaignClick(campaign)}
                        >
                            <div
                                className="campaign-thumbnail"
                                style={{
                                    backgroundImage: `url(${campaign.url || campaign.image})`,
                                }}
                            >
                                <div className="campaign-overlay" />
                                <div className="campaign-title">
                                    {campaign.name}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Campaign Modal */}
            {showModal && selectedCampaign && (
                <div className="campaign-modal-overlay" onClick={() => setShowModal(false)}>
                    <button
                        type="button"
                        onClick={showPreviousCampaign}
                        className="text-white hover:text-yellow-300 transition-colors"
                        style={{
                            position: "fixed",
                            left: "24px",
                            top: isMobile ? "33%" : "50%",
                            transform: "translateY(-50%)",
                            zIndex: 60,
                            fontSize: "30px",
                            backgroundColor: "rgba(0, 0, 0, 0.65)",
                            border: "2px solid rgba(255, 255, 255, 0.75)",
                            borderRadius: "9999px",
                            width: "56px",
                            height: "56px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <FiChevronLeft />
                    </button>
                    <div className="campaign-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="campaign-modal-header">
                            <h2 className="campaign-modal-title">{selectedCampaign.name}</h2>
                            <button
                                className="campaign-modal-close"
                                onClick={() => setShowModal(false)}
                            >
                                <FiX />
                            </button>
                        </div>
                        <div className="campaign-modal-body">
                            <img
                                src={selectedCampaign.url || selectedCampaign.image}
                                alt={selectedCampaign.name}
                                className="campaign-modal-image"
                            />
                            <div className="campaign-modal-details">
                                <div className="campaign-modal-notes">
                                    {selectedCampaign.enNotesArray?.map((note, index) => (
                                        <p key={`en-${index}`}>{note}</p>
                                    ))}
                                    {selectedCampaign.cnNotesArray?.map((note, index) => (
                                        <p key={`cn-${index}`}>{note}</p>
                                    ))}
                                </div>
                                <div className="campaign-thumbnails">
                                    {selectedCampaign.thumbnails?.map((thumbnail, index) => (
                                        <img
                                            key={index}
                                            src={thumbnail}
                                            alt={`${selectedCampaign.name} thumbnail ${index + 1}`}
                                            className="campaign-thumbnail-small"
                                        />
                                    ))}
                                </div>
                                <p className="text-sm text-gray-400 mt-4">Terms & conditions apply.</p>
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={showNextCampaign}
                        className="text-white hover:text-yellow-300 transition-colors"
                        style={{
                            position: "fixed",
                            right: "24px",
                            top: isMobile ? "33%" : "50%",
                            transform: "translateY(-50%)",
                            zIndex: 60,
                            fontSize: "30px",
                            backgroundColor: "rgba(0, 0, 0, 0.65)",
                            border: "2px solid rgba(255, 255, 255, 0.75)",
                            borderRadius: "9999px",
                            width: "56px",
                            height: "56px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <FiChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default withUser(Campaigns);
